// FILE: src/utils/profileAvatar.js

const appendVersionToUrl = (url, version) => {
  if (!url) return null;
  if (!version) return url;

  try {
    const base =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "http://localhost";

    const parsedUrl = new URL(url, base);
    parsedUrl.searchParams.set("v", String(version));

    // If the original input was relative, preserve relative output
    if (!/^https?:\/\//i.test(url) && !url.startsWith("//")) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }

    return parsedUrl.toString();
  } catch {
    const separator = url.includes("?") ? "&" : "?";
    return `${url}${separator}v=${encodeURIComponent(String(version))}`;
  }
};

export const getProfileAvatarUrl = (profileDetails = {}) => {
  if (!profileDetails) return null;

  const blobUrl = profileDetails.profile_picture_blob_url || null;
  const version = profileDetails.profile_picture_version || null;

  if (blobUrl) {
    return appendVersionToUrl(blobUrl, version);
  }

  return (
    profileDetails.profile_picture_url ||
    profileDetails.profile_picture_source_url ||
    profileDetails.profile_image ||
    null
  );
};

export const withResolvedProfileAvatar = (profileDetails = {}) => {
  const resolvedAvatarUrl = getProfileAvatarUrl(profileDetails);

  return {
    ...profileDetails,
    profile_picture_url:
      resolvedAvatarUrl ||
      profileDetails.profile_picture_url ||
      profileDetails.profile_picture_source_url ||
      profileDetails.profile_image ||
      null,
    profile_image:
      resolvedAvatarUrl ||
      profileDetails.profile_image ||
      profileDetails.profile_picture_url ||
      profileDetails.profile_picture_source_url ||
      null,
  };
};